module.exports = __webpack_public_path__ + "static/media/highlight.b7c522b2.png";